module.exports = __webpack_public_path__ + "static/images/voice-btn-icon.d96877c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/edit/config/voice-btn-icon.png
// module id = BlPI
// module chunks = 6 7